module.exports = __webpack_public_path__ + "img/rs.6f45db5.svg";